import { useLPActions } from 'components/actions/useLPActions'
import { Block } from 'components/Block'
import { SActionCards } from './GuidebookFeatureList.styled'
import { useTranslation } from 'next-i18next'

export function GuidebookFeatureList() {
  const { t } = useTranslation('eol_guide')
  const { t: tCommon } = useTranslation()

  const actions = useLPActions(
    [
      'eol_family_history',
      'eol_social_media',
      'eol_protect_accounts',
      'eol_documents',
      'eol_future_messages',
    ],
    {
      forAll: {
        titleAs: 'h3',
        buttonText: tCommon('common.learn_more'),
        renderAsFullyClickableLink: true,
      },
    }
  )

  return (
    <Block>
      <SActionCards
        variant="round-button"
        actions={actions}
        title={t('eol_guide.action_cards_title')}
      />
    </Block>
  )
}
